<div class="w-100 flex-col justify-start items-stretch" [formGroup]="kvpForm">
  <button mat-stroked-button color="primary" class="uppercase" (click)="onAddComponentClick()">
    {{addButtonLabel}}
  </button>
  <div formArrayName="components" class="component-list">
    @for (component of formArr.controls; track component; let i = $index) {
      <div [formGroupName]="i" class="component-box">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-30" >
          <mat-label>{{keyOptions().length > 0 ? 'Field' : keyLabel}}</mat-label>
          @if (keyOptions().length > 0) {
            <mat-select formControlName="key" placeholder="Select field" required>
              @if (isStaleKey(formGroup(i).get('key')?.value)) {
                <mat-option [value]="formGroup(i).get('key')?.value" disabled>{{formGroup(i).get('key')?.value}} (not in file definition)</mat-option>
              }
              @for (option of keyOptions(); track option) {
                <mat-option [value]="option">{{option}}</mat-option>
              }
            </mat-select>
          }
          @else {
            <input matInput formControlName="key" autocomplete="off" type="text" required>
          }
          @if (formGroup(i).get('key')?.errors?.['required']) { <mat-error>Input is required</mat-error> }
          @if (formGroup(i).get('key')?.errors?.['notInFileDefinition']) { <mat-error>Field not in selected file definition</mat-error> }
          @if (formGroup(i).get('key')?.errors?.['duplicateKey']) { <mat-error>Duplicate key</mat-error> }
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-60" >
          <mat-label>{{valueLabel}}</mat-label>
          <input matInput formControlName="value" autocomplete="off" type="text" required>
          @if (formGroup(i).get('value')?.errors?.['required']) { <mat-error>Input is required</mat-error> }
        </mat-form-field>
        <div class="w-10 pt-3">
          <button mat-icon-button class="delete-button" (click)="deleteComponent(i)" matTooltip="Delete">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</div>
